/*
 * JOINED TEXT FIELD VALUE
 *
 * Converts between a title-first text value and the separate title/body fields shown in
 * reusable joined popup controls.
 *
 * Recent changes:
 * - Added lossless line splitting and composition for task and note popup fields.
 */

export interface JoinedTextValue {
  title: string;
  body: string;
}

export const splitJoinedText = (value: string): JoinedTextValue => {
  const [title = '', ...bodyLines] = value.split(/\r?\n/);
  return {
    title,
    body: bodyLines.join('\n'),
  };
};

export const composeJoinedText = (title: string, body: string): string => (
  body ? `${title}\n${body}` : title
);
